import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { FiltersFormT } from "./filters.schema";
import { Combobox } from "../../../components/ui/combobox";
import { useState } from "react";
import { boatsFetch } from "../../../lib/boatsFetch";

type YachtName = {
  name: string;
  entityType: "yacht";
};

export const YachtName = ({ defaultValue }: { defaultValue?: YachtName["name"] }) => {
  const [yachtName, setYachtName] = useState<YachtName | null>(
    defaultValue ? { entityType: "yacht", name: defaultValue } : null,
  );

  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Name</h3>
      <FormField<FiltersFormT, "yachtName">
        name="yachtName"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Combobox<YachtName>
                className="flex w-96"
                loadOptions={(query) => {
                  const data = boatsFetch<{ data: any[]; success: boolean }>(
                    `/search/yacht-names${query ? `?query=${query}` : ""}`,
                  ).then((r) => r.data);
                  return data;
                }}
                placeholder="Search for yacht..."
                value={yachtName}
                onChange={(v) => {
                  if (v && v.name[0] !== yachtName?.name[0]) {
                    setYachtName(v);
                    field.onChange(v.name[0]);
                  } else {
                    setYachtName(null);
                    field.onChange("");
                  }
                }}
                renderOption={(r) => r.name[0]}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};
